import React from 'react';
import './homeComponent.css'
// TODO(asset): replace with AI hero image
import mainPageImage from '../../assets/home-page-img.svg'
import { TypeAnimation } from 'react-type-animation';

const AnimatedText = () => {
    return (
        <div>
            <TypeAnimation
                className='first-text-home-component'
                sequence={[
                    "Build AI Agents That Work While You Sleep.",
                    2000,
                    "Ship Multi-Agent Pipelines in Days, Not Months.",
                    2000,
                    "Turn Your Business Data Into an Intelligent System.",
                    2000,
                    "Automate Workflows with Agentic AI That Thinks.",
                    2000,
                    "We Build the AI Infrastructure of Your Business.",
                    2000
                ]}
                speed={50}
                repeat={Infinity}
            />
        </div>
    );
};


const HomeComponent = () => {

    return (
        <div className='home-component' id='home-component'>
            <div className='home-component-para'>
                <AnimatedText />
                <p className='second-text-home-component'>We are a specialized AI engineering team building autonomous agent systems, RAG pipelines, MCP integrations, and voice AI interfaces for businesses entering the agentic era. From prototype to production in weeks - not quarters.</p>
            </div>
            <img src={mainPageImage} alt="Logo with title" className='home-component-image' />
        </div >
    )
}

export default HomeComponent;